import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Library from './pages/Library';
import Practice from './pages/Practice';
import Community from './pages/Community';
import Profile from './pages/Profile';
import CategoryPage from './pages/CategoryPage';
import BundlePage from './pages/BundlePage';
import ScenarioPage from './pages/ScenarioPage';
import Onboarding from './pages/Onboarding';
import AuthPageRoute from './pages/AuthPageRoute';
import Admin from './pages/Admin';
import Pricing from './pages/Pricing';
import PremiumWelcome from './pages/PremiumWelcome';
import Affirmations from './pages/Affirmations';
import { useAppStore } from './store/appStore';

function App() {
  const user = useAppStore((s) => s.user);

  // Guest users (tier='guest') are allowed through without child profiles
  const isGuest = user?.tier === 'guest';
  const isOnboarded =
    isGuest ||
    (user && user.name && user.name !== 'Parent' && user.childProfiles.length > 0);

  return (
    <BrowserRouter>
      <Routes>
        {/* Always public — no auth required */}
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/auth" element={<AuthPageRoute />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/premium/welcome" element={<PremiumWelcome />} />

        {!isOnboarded ? (
          <Route path="*" element={<Navigate to="/onboarding" replace />} />
        ) : (
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/library" element={<Library />} />
            <Route path="/library/category/:categoryId" element={<CategoryPage />} />
            <Route path="/library/bundle/:bundleId" element={<BundlePage />} />
            <Route path="/library/scenario/:scenarioId" element={<ScenarioPage />} />
            <Route path="/affirmations" element={<Affirmations />} />
            <Route path="/practice" element={<Practice />} />
            <Route path="/community" element={<Community />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
